import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_mendesteodo.png",
      alt: "Estratégias Mendes Teodo",
    },
    title: "Opere com a Mendes Teodo",

    // String ou array de strings
    text: [
      "A Mendes Teodo é uma empresa voltada para o estudo de trade quantitativo usando os dados a favor dos investidores, desenvolvemos fórmulas e cálculos e homologamos em nossas sistemas de forma 100% automatizada, tirando toda a emoção e ansiedade do trader, conheça os nossos sistemas e permita que possamos lhe entregar os primeiros resultados na bolsa de valores com robôs investidores.",
    ],
    // testimonial: {
    //   text: "",
    //   author: {
    //     name: "",
    //     picture: "",
    //   },
    // },
  },

  strategies: {
    title: "Estratégias da Mendes Teodo",
    heading: "Estratégia pensada e desenhada para você.",
    subtitle:
      "Estratégias prontas e desenvolvidas por estudiosos no mercado financeiro para pequenos, médios e grandes investidores, inicie agora mesmo.",
  },

  cta: {
    title: "Pronto para dar o play",
    subtitle: "e lucrar com a gente?",
  },

  about: {
    title: "Sobre a empresa",
    subtitle: "A Mendes Teodo",
    col1: [
      "Nossa empresa nasceu em meados de 2019 com foco em desenvolver sistemas e automatizações exclusivamente para o mercado financeiros, oferecendo a oportunidade a seus clientes para operar com robô que realmente possa gerar bons resultados e com consistência.",
    ],
    // col2: [
    //   "Oferecemos aos clientes da OnTick um portfólio com múltiplas estratégias validadas pelo período de pelo menos 2 anos em conta real, com resultado médio muito superior às estratégias isoladas.",
    // ],
  },

  // stats: {
  //   title: "Alguns números do portfólio WinnerBot*",
  //   subtitle:
  //     "Mais de 7 anos de experiência operando de forma automatizada em escala global.",
  //   smalltext: "*Baseado no lote mínimo recomendado do portfólio.",
  //   data: [
  //     {
  //       value: "72",
  //       description: "Número de Meses",
  //     },
  //     {
  //       value: "63",
  //       description: "Meses com Gain",
  //     },
  //     {
  //       value: "9",
  //       description: "Meses com Perda",
  //     },
  //   ],
  // },

  features: {
    title: "Por que utilizar os robôs da Mendes Teodo?",
    subtitle: "Veja quais as principais vantagens dos robôs da Mendes Teodo.",
    data: [
      // {
      //   icon: iconsSet.click,
      //   title: "Simplicidade",
      //   description:
      //     "Estratégias simples, comprovadamente rentáveis e cuidadosamente otimizadas e testadas em conta real.",
      // },
      // {
      //   icon: iconsSet.code,
      //   title: "100% automatizado",
      //   description:
      //     "Realizamos todos os ajustes e parametrizações das estratégias automaticamente.",
      // },
      // {
      //   icon: iconsSet.pie_chart_2,
      //   title: "Opere um portfólio",
      //   description:
      //     "Oferecemos um portfólio balanceado, priorizando sempre uma curva de capital suave com ótima relação gain x drawdown.",
      // },
      ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Mendes Teodo",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
